import BaseRepository from '@/repositories/base/BaseRepository';

class VirtualCurrencyRepository extends BaseRepository {
    // 获取酒店账户带客金立即领取、使用带客金、暂停使用带客金、加金币按钮限制
    getHotelAccountButton() {
      return this.get<any>({
        url: '/ebk-dkb-api/daikebi-account-info/get-hotel-account-button',
        data: {},
      });
    }  
    //带客金订单创建
    createDaikebi(params:any) {
        return this.post<any>({
          url: '/ebk-dkb-api/extension/create-daikebi',
          data: params,
        });
    }
    //带客金营业额增幅图
    turnoverIncreaseChart(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-account-info/turnover-increase-chart',
            data: params,
        });
    } 
    //酒店领取带客金
    hotelReceiveCoin(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-account-info/hotel-receive-coin',
            data: params,
        });
    } 
    //获取酒店数据概览
    getHotelDataOverview() {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-account-info/get-hotel-data-overview',
            data: {},
        });
    }
    //带客金酒店账户概览
    getHotelAccountInfo() {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-account-info/get-hotel-account-info',
            data: {},
        });
    }
    //带客金订单修改
    modifyDaikebi(params:any) {
        return this.post<any>({
          url: '/ebk-dkb-api/extension/modify-daikebi',
          data: params,
        });
    }
    //带客金推广计划订单状态变更
    daiKeBiStatusChange(params:any) {
        return this.post<any>({
          url: '/ebk-dkb-api/cpcAd/daiKeBiStatusChange',
          data: params,
        });
    }
    //获取cpc推广订单详情
    getCpcAdDetail(params:any) {
        return this.post<any>({
          url: '/ebk-dkb-api/cpcAd/getCpcAdDetail',
          data: params,
        });
    }

    //酒店账户阶梯进度
    hotelAccountProgress() {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-account-info/hotel-account-progress',
            data: {platformSource:1},
        });
    }

    //cpc推广计划日志查询
    getJournalDetail(params:any) {
        return this.post<any>({
          url: '/ebk-dkb-api/cpcAd/getJournalDetail',
          data: params,
        });
    }
    //带客金酒店待领取订单集合
    getWaitDrawOrderList(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-apply-order/get-wait-draw-order-list',
            data: params,
        });
    } 
    //带客金酒店待领取订单集合下载
    exportWaitDrawOrderList(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-apply-order/export-wait-draw-order-list',
            responseType: 'arraybuffer',
            data: params,
        });
    } 
    //带客金酒店充值记录集合
    getRechargeOrderList(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-apply-order/get-recharge-order-list',
            data: params,
        });
    } 
    //带客金酒店充值记录集合下载
    exportRechargeOrderList(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-apply-order/export-recharge-order-list',
            responseType: 'arraybuffer',
            data: params,
        });
    } 
    //带客金酒店消耗记录集合
    getConsumeOrderList(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-apply-order/get-consume-order-list',
            data: params,
        });
    }
    //带客金酒店消耗记录集合下载
    exportConsumeOrderList(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-apply-order/export-consume-order-list',
            responseType: 'arraybuffer',
            data: params,
        });
    } 
    //带客金可带来订单收入预估
    daikebiOrderIncomeForecast() {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-account-info/daikebi-order-income-forecast',
            data: {},
        });
    }

    //带客金订单修改带客金托管智投状态
    modifySmartDeliveryDaikebi(params:any) {
        return this.post<any>({
            url: '/ebk-dkb-api/extension/modify-smart-delivery-daikebi',
            data: params,
        });
    }

    // 开启带客金托管智投后的曝光提升预估
    smartDeliveryForecast(params:any) {
        return this.post<any>({
            url: '/ebk-dkb-api/extension/smart-delivery-forecast',
            data: params,
        });
    }

    // 自动领取带客币
    autoReceiveCoin(params:any) {
        return this.post<any>({
            url: '/ebk-dkb-api/daikebi-account-info/auto-receive-coin',
            data: params,
        });
    }

    // 带客币托管智投2.0弹窗
    popWindow(params:any) {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-account-info/pop-window',
            data: params,
        });
    }

    // 获取带客币酒店账户配置
    getConfig() {
        return this.get<any>({
            url: '/ebk-dkb-api/daikebi-account-info/get-config',
            data: {},
        });
    }
    
  }
  
  export default VirtualCurrencyRepository;
  
